import { themeAtom } from "../../../../../shared/atoms";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = {
  rowCountLabel: string;
  isRefreshing: boolean;
  onRefresh: () => void;
};

const AdminCertificatesSettingsTopBar = ({ rowCountLabel, isRefreshing, onRefresh }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <header
      data-test="admin-certificates-settings-top-bar"
      className="relative z-50 flex h-11 flex-none items-center border-b border-gray-200 bg-white px-3 dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden pr-3">
        <h1 className={twMerge("min-w-0 truncate text-sm font-semibold leading-5", theme.home.tailwind.textDefault)}>
          Certificates Settings
        </h1>
        <span
          className="hidden flex-none border border-[#D7E2DE] px-2 py-1 text-[11px] font-semibold text-[#4A5655] md:inline-flex"
          data-test="admin-certificates-settings-count"
        >
          {rowCountLabel}
        </span>
      </div>
      <button
        type="button"
        aria-label="Refresh certificates settings"
        title="Refresh"
        data-test="admin-certificates-settings-refresh"
        disabled={isRefreshing}
        onClick={onRefresh}
        className="inline-flex h-8 w-8 flex-none items-center justify-center border border-gray-300 text-green transition-colors hover:bg-[#E9F4F3] disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700"
      >
        <ArrowPathIcon className={twMerge("h-4 w-4", isRefreshing && "animate-spin")} />
      </button>
    </header>
  );
};

export default AdminCertificatesSettingsTopBar;
